export enum PaginationItemType {
  Page = 'page',
  Ellipsis = 'ellipsis',
}

export type PaginationItem =
  | {
      type: PaginationItemType.Page
      page: number
      hiddenInCondensedView?: boolean
    }
  | {
      type: PaginationItemType.Ellipsis
      key: string
      condensedViewOnly?: boolean
    }

export type PaginatedGalleryRoute =
  | 'content'
  | 'search'
  | 'dynamic'
  | 'pay-per-click'
  | 'collections'
